import ApiService from "@/app/infrastructures/services/ApiService";
import { OperationalAreaMapper } from "@/data/persistences/mappers/OperationalAreaMapper";
import { OperationalAreaEndpoint } from "../../endpoints/OperationalAreaEndpoint";
import {
  UrsaCodeList,
  UrsaCodeListRequest
} from "@/domain/entities/OperationalArea";

export class OperationalApiRepository {
  private service: ApiService;
  private mapper: OperationalAreaMapper;
  private endpoints: OperationalAreaEndpoint;

  constructor(
    service: ApiService,
    mapper: OperationalAreaMapper,
    endpoints: OperationalAreaEndpoint
  ) {
    this.service = service;
    this.mapper = mapper;
    this.endpoints = endpoints;
  }

  public async getUrsaCodeList(
    params: UrsaCodeListRequest
  ): Promise<UrsaCodeList> {
    const response = await this.service.invoke(
      "get",
      this.endpoints.getUrsaCodeList(params),
      {}
    );
    return this.mapper.convertUrsaCodeListFromApi(response);
  }

  async getUrsaDetail(ursaCode: string) {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getUrsaCodeDetail(ursaCode)
    )

    return this.mapper.convertUrsaCodeDetailFromApi(resp);
  }

  async updateUrsaStatus(ursaCode: string, status: boolean) {
    await this.service.invoke(
      "put",
      this.endpoints.getUrsaCodeDetail(ursaCode),
      undefined,
      {
        toJSON: () => {
          return JSON.stringify({
            "is_active": status
          })
        }}
    )

    return true;
  }
}

